export default __webpack_public_path__ + "static/boat-white-2963b1283e6173d184f6a6377a390ffa.png";